import Button from '../../../components/common/button/Button';
import Input from '../../../components/common/input/Input';
import Checkbox from '../../../components/common/checkbox/Checkbox';
import codevisionLogo from '../../../assets/covi_logo_white.png';
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {loginAPI} from '../../../services/auth';
import styles from './LoginPage.module.css';

interface Credentials {
    username: string;
    password: string;
}

//로그인 페이지
const LoginPage: React.FC = () => {
    const [credentials, setCredentials] = useState<Credentials>({
        username: '',
        password: ''
    });
    const [errors, setErrors] = useState<{
        username?: string;
        password?: string;
    }>({});
    const [keepLoggedIn, setKeepLoggedIn] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    //입력
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const {name, value} = e.target;
        setCredentials(prev => ({
            ...prev,
            [name]: value.trim()
        }));
        setErrors(prev => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
        e.preventDefault();
        setErrors({});

        const newErrors: { username?: string; password?: string } = {};
        //ID 입력 필수
        if (!credentials.username) {
            newErrors.username = 'ID를 입력하세요';
        }
        //비밀번호 입력 필수
        if (!credentials.password) {
            newErrors.password = '비밀번호를 입력하세요';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setIsLoading(true);

        try {
            //로그인 API
            const response = await loginAPI(credentials, keepLoggedIn);
            //역할에 맞는 화면으로 이동
            if (response.role === 'ADMIN') {
                navigate("/admin");
            } else {
                navigate("/client", {state: {loginInfo: response}});
            }
        } catch (error) {
            console.error('Login failed:', error);

            setCredentials(prev => ({
                ...prev,
                password: ''
            }));
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <div className={styles.loginContainer}>
                <img src={codevisionLogo} alt="Codevision Logo" className={styles.logo}/>
                <div className={styles.loginBox}>
                    <h2>로그인</h2>
                    <div className={styles.register}>
                        <p>
                            계정이 없으신가요? {' '}
                            {/*회원가입 규정 화면으로 이동*/}
                            <a href="/register/term" className={styles.forgotPassword}>
                                회원가입
                            </a>
                        </p>
                    </div>

                    <form onSubmit={handleSubmit} noValidate>
                        {/*ID 입력창*/}
                        <Input
                            label="ID"
                            name="username"
                            value={credentials.username}
                            onChange={handleChange}
                            placeholder="ID"
                            fullWidth
                            lang="en"
                            required
                            disabled={isLoading}
                            autoFocus
                            error={errors.username}
                            style={{paddingRight: '0px'}}
                        />
                        {/*비밀번호 입력창*/}
                        <Input
                            label="비밀번호"
                            type="password"
                            name="password"
                            value={credentials.password}
                            onChange={handleChange}
                            placeholder="비밀번호"
                            fullWidth
                            lang="en"
                            required
                            disabled={isLoading}
                            error={errors.password}
                            style={{paddingRight: '0px'}}
                        />

                        <div className={styles.options}>
                            {/*자동로그인 선택*/}
                            <Checkbox
                                label="자동 로그인"
                                checked={keepLoggedIn}
                                onChange={(e) => setKeepLoggedIn(e.target.checked)}
                                disabled={isLoading}
                            />
                            {/*비밀번호 찾기 화면으로 이동*/}
                            <a href="/find-password" className={styles.forgotPassword}>
                                비밀번호 찾기
                            </a>
                        </div>
                        {/*로그인 버튼*/}
                        <Button
                            type="submit"
                            variant="primary"
                            size='large'
                            fullWidth
                            disabled={isLoading}
                        >
                            {isLoading ? '로그인 중...' : '로그인'}
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;